let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("r2GGB")).then(() => parcelRequire('1jjJq'));